import module from 'nominas/finiquitos/module.js'

const schema = {}

export class NominasFiniquitosProyectosService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/nominas/finiquitos/proyectos', {
      schema,
    })
  }
}

module.service('NominasFiniquitosProyectos', NominasFiniquitosProyectosService)



// WEBPACK FOOTER //
// ./src/nominas/finiquitos/services/finiquitos/Proyectos.js